<script setup lang="ts">
import Navigation from "@/components/Navigation.vue";
</script>

<template>
    <div class="font-sans bg-black min-h-screen text-white">
        <Navigation />
        <router-view />
    </div>
</template>

<style lang="scss">
#app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
</style>
